import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import SEOHead from "@/components/feature/SEOHead";
import HeroBanner from "./components/HeroBanner";
import CategoryCards from "./components/CategoryCards";
import FeaturedArticles from "./components/FeaturedArticles";
import LatestArticles from "./components/LatestArticles";

export default function Home() {
  const pageTitle = "芒果视频——西瓜视频和小蓝视频的同类替代选择 | 茄子视频丝瓜视频之外免费高清在线看";
  const pageDescription = "芒果视频作为西瓜视频、小蓝视频的同类应用，提供免费高清在线观看服务。类似茄子视频、丝瓜视频等平台，芒果视频替代首选，资源全画质好。芒果视频，不缓冲的免费高清在线观看体验。";
  const pageKeywords = "芒果视频,芒果视频类似西瓜视频,芒果视频替代,芒果视频和小蓝视频,芒果视频同类,西瓜视频,小蓝视频,茄子视频,丝瓜视频,免费高清在线观看,不缓冲";

  const schemaData = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        name: "芒果视频",
        url: "https://mangguoshipin.com",
        logo: "https://mangguoshipin.com/logo.png",
        description: "芒果视频作为西瓜视频、小蓝视频的同类替代选择，提供免费高清在线观看服务。",
        contactPoint: {
          "@type": "ContactPoint",
          telephone: "400-888-6666",
          contactType: "customer service",
          availableLanguage: "Chinese",
        },
        address: {
          "@type": "PostalAddress",
          addressLocality: "长沙",
          addressRegion: "湖南",
          addressCountry: "CN",
        },
      },
      {
        "@type": "WebSite",
        name: "芒果视频",
        url: "https://mangguoshipin.com",
        description: pageDescription,
        potentialAction: {
          "@type": "SearchAction",
          target: "https://mangguoshipin.com/search?q={search_term_string}",
          "query-input": "required name=search_term_string",
        },
      },
      {
        "@type": "WebPage",
        name: pageTitle,
        description: pageDescription,
        url: "https://mangguoshipin.com",
        isPartOf: {
          "@type": "WebSite",
          name: "芒果视频",
          url: "https://mangguoshipin.com",
        },
      },
    ],
  };

  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title={pageTitle}
        description={pageDescription}
        keywords={pageKeywords}
        canonicalUrl="https://mangguoshipin.com"
        schemaData={schemaData}
      />
      <Header />
      <main>
        <HeroBanner />
        <CategoryCards />
        <FeaturedArticles />
        <LatestArticles />
      </main>
      <Footer />
    </div>
  );
}